import React, { useContext, useEffect, useState, useCallback } from "react";
import { PhysioReviewContext } from "./PhysioReviewFormProvider";
import { getPhysioReviewAPI } from "../../../../services/physio.services";
import { Button, Col, message, Row, Spin, Tag } from "antd";
import PhysioFunctionalDiagnosisSummary from "../../InspectionSummaries/FunctionalExaminationSummary/PhysioFunctionalDiagnosisSummary";
import PhysioTreatmentPlanSummary from "../../InspectionSummaries/TreatmentPlan/PhysioTreatmentPlanSummary";
import PhysioScalesReviewSummary from "../../InspectionSummaries/Scales/PhysioScalesReviewSummary";
import { checkEmpty } from "../../../../helpers/utility";
import dayjs from "dayjs";
import EditIcon from "../../../ui/EditIcon";
import btnStyles from "../../../../styles/Custom/Button.module.css";
import "../../summary.css";
import "../../Doctor/DailyReview/DailyReview.css";

const PhysioReviewSummary = ({
  editId,
  visible,
  dailyRefresh,
  isActive = false,
  onEdit,
  canEdit = false,
}) => {
  const { formData, setFormData } = useContext(PhysioReviewContext);
  const [loading, setLoading] = useState(false);

  const openEdit = useCallback(async () => {
    if (!editId) {
      return;
    }
    setLoading(true);
    try {
      const response = await getPhysioReviewAPI(editId);
      setFormData(response.data.data);
    } catch (error) {
      console.log(`Error: ${error}`);
      message.error("Unable to Fetch Data");
    } finally {
      setLoading(false);
    }
  }, [editId, setFormData]);

  useEffect(() => {
    openEdit();
  }, [openEdit, dailyRefresh]);

  return (
    <Spin
      spinning={loading}
      tip="Loading review data..."
      style={{ minHeight: 240, width: "100%" }}
    >
      <Row className="summaries daily-review-summaries" gutter={[16, 16]}>
        <Col span={24}>
          <div className="daily-review-meta-bar">
            {(formData?.submitted_by_first_name ||
              formData?.submitted_by_last_name) && (
              <Tag className="daily-review-meta-tag--submitted">
                Submitted by: {formData?.submitted_by_first_name || ""}{" "}
                {formData?.submitted_by_last_name || ""}
              </Tag>
            )}
            <div className="daily-review-meta-bottom">
              {formData?.updated_at && (
                <Tag className="daily-review-meta-tag--updated">
                  Updated at:{" "}
                  {dayjs(formData?.updated_at).format("DD/MM/YYYY hh:mm A")}
                </Tag>
              )}
              {isActive && (
                <div className="daily-review-meta-actions--mobile">
                  <Button
                    type="primary"
                    onClick={onEdit}
                    className={`${btnStyles.lgBtn} inv-btn`}
                    disabled={!canEdit}
                    style={{ fontWeight: 500 }}
                  >
                    <EditIcon />
                    Edit
                  </Button>
                </div>
              )}
            </div>
          </div>
        </Col>
        <Col xs={24} md={12}>
          {checkEmpty(formData?.functional_diagnosis) && (
            <PhysioFunctionalDiagnosisSummary formData={formData} />
          )}
          {checkEmpty(formData?.treatment_plan) && (
            <PhysioTreatmentPlanSummary formData={formData} />
          )}
        </Col>
        <Col xs={24} md={12}>
          {checkEmpty(formData?.scales) && (
            <PhysioScalesReviewSummary
              formData={formData}
              editId={editId}
              visible={visible}
            />
          )}
        </Col>
      </Row>
    </Spin>
  );
};

export default PhysioReviewSummary;
